module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page upload-child video-page broadcast-page create-page mx-5 margin-top-header"
  }, [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "mt-5 text-poppins-36"
  }, [_vm._v("Broadcast live")]), _vm._v(" "), (_vm.activeView == 'intro') ? _c('videoEstimate', {
    on: {
      "gotoNextView": _vm.gotoNextView
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeView == 'initStream') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.openPaymentDialog()
      }
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-20 pa-4 mt-4"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("Info")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "gap-20": "",
      "broadcast-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('div', [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "__title"
  }, [_vm._v("Title of Event")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.name),
      expression: "stream.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "title",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.stream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                  Category\n                ")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.genres,
      "name": "genre",
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    model: {
      value: (_vm.stream.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.stream, "genre_id", $$v)
      },
      expression: "stream.genre_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_vm._v("Description")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.description),
      expression: "stream.description"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "4000"
    },
    domProps: {
      "value": (_vm.stream.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                  Live event thumbnail\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-container"
  }, [_c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream_cover_url + ')',
    })
  }) : _c('div', {
    staticClass: "video-thumbnail"
  }, [_c('div', {
    staticClass: "cover-wrapper allChildrenCenter"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "stream_cover_file",
      "id": "stream_cover_file",
      "accept": ".png, .jpg, .jpeg"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [(_vm.stream_cover_url) ? _c('span', {
    staticClass: "app-blue--text"
  }, [_vm._v("Change")]) : _c('span', {
    staticClass: "texet-xs-center dflex align-center justify-center flex-column"
  }, [_c('img', {
    attrs: {
      "width": "20",
      "src": "/static/images/ic_camera.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("ADD IMAGE")])])])])])]), _vm._v(" "), (_vm.stream_cover_url) ? _c('div', {
    staticClass: "cover-wrapper mt-2"
  }, [_c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [_c('span', {
    staticClass: "app-blue--text"
  }, [_vm._v("Change")])])]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-20 pa-4 mt-4"
  }, [_vm._m(0), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "gap-20": "",
      "broadcast-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pay per view price\n                  ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "view_price",
      "disabled": ""
    },
    domProps: {
      "value": _vm.stream_view_price
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Capacity")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.viewers_limits,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.viewers_limit),
      callback: function($$v) {
        _vm.$set(_vm.stream, "viewers_limit", $$v)
      },
      expression: "stream.viewers_limit"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "submit-section mt-4"
  }, [_c('v-btn', {
    staticClass: "release-now-btn white--text",
    attrs: {
      "round": "",
      "type": "submit"
    }
  }, [_vm._v("\n            Release\n          ")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-card-media', {
    attrs: {
      "src": "/static/images/post1.jpg",
      "contain": ""
    }
  }), _vm._v(" "), _c('label', [_vm._v("Live Video")])], 1), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_vm._v("\n            Attach albums & products to live video to "), _c('br'), _vm._v("let user\n            "), _c('b', [_vm._v("download")]), _vm._v(" or "), _c('b', [_vm._v("add to cart")]), _vm._v(" while viewing.\n          ")]), _vm._v(" "), _c('li', [_vm._v("Make albums & products "), _c('b', [_vm._v("exclusive")]), _vm._v(" on broadcast.")]), _vm._v(" "), _c('li', [_vm._v("\n            Let users view for "), _c('b', [_vm._v("Free")]), _vm._v(" or "), _c('b', [_vm._v("Pay Per View")]), _vm._v("."), _c('br'), _vm._v("Charge\n            up to $10,000 per user.\n          ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Limit")]), _vm._v(" the amount of viewers on your broadcast.")]), _vm._v(" "), _c('li', [_vm._v("Add users to your "), _c('b', [_vm._v("Guest List")]), _vm._v(" to watch for free.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dailog-1",
      "persistent": ""
    },
    model: {
      value: (_vm.show_stripe_connect_dialog),
      callback: function($$v) {
        _vm.show_stripe_connect_dialog = $$v
      },
      expression: "show_stripe_connect_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Stripe Connect")]), _vm._v(" "), _c('div', [_vm._v("You have to connect stripe in setting page.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStripeConnectDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "stream-collaborators-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.show_collaborators_dialog),
      callback: function($$v) {
        _vm.show_collaborators_dialog = $$v
      },
      expression: "show_collaborators_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n          Collaborators Pay Per View Split\n        ")])]), _vm._v(" "), _c('v-card-text', [_c('div', [_c('div', [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1), _vm._v(" "), (_vm.stream.view_price > 0 && _vm.stream.collaborators.length < 3) ? _c('div', [_c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add another collaborator\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.stream.collaborators && _vm.stream.collaborators.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Creator"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.currentUser.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit Share"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.creator_recoup_cost),
      expression: "stream.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.stream.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "creator_recoup_cost", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.stream.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "collaborator-wrapper": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "autocomplete": "",
        "no-data-text": "No collaborator available",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                    " + _vm._s(data.item.username) + "\n                  ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit Share"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("clear")])], 1)
  })], 2)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeCollaboratorsDialog()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), (_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.streamCost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.deposit
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("Options")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a02d3bb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/create.vue
// module id = 1663
// module chunks = 180